import _ from 'underscore';

export function verifyDepsExist(deps, expectedDeps = []) {
  const missing = _.difference(expectedDeps, _.keys(_.pick(deps, Boolean)));
  if (missing.length) {
    throw new Error(`Expected the following deps to be passed in: ${missing.join(',')}`);
  }
}
